import { render, staticRenderFns } from "./DictData.vue?vue&type=template&id=04de2b2e"
import script from "./DictData.vue?vue&type=script&lang=js"
export * from "./DictData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports